var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 6.27271C6.79636 6.27271 5.81819 7.25087 5.81819 8.45452C5.81819 9.65816 6.79636 10.6363 8.00001 10.6363C9.20366 10.6363 10.1818 9.65816 10.1818 8.45452C10.1818 7.25087 9.20363 6.27271 8.00001 6.27271Z",
    fill: "#969EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 3C4.36364 3 1.25819 5.2618 0 8.45455C1.25819 11.6473 4.36364 13.9091 8.00002 13.9091C11.64 13.9091 14.7418 11.6473 16 8.45455C14.7418 5.2618 11.64 3 8.00002 3ZM8.00002 12.0909C5.99274 12.0909 4.36364 10.4618 4.36364 8.45451C4.36364 6.44724 5.99274 4.81817 8.00002 4.81817C10.0073 4.81817 11.6364 6.44728 11.6364 8.45455C11.6364 10.4618 10.0073 12.0909 8.00002 12.0909Z",
    fill: "#969EB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.af1f0435bedf753a583e34f77b6caa69.svg";
export { ForwardRef as ReactComponent };